import { defineComponent as _defineComponent } from 'vue'
import { WebLocale } from '@/enums/web-locale';
import { getVm } from '@/helpers/vm-helper';
import {
	reverseCategoryQueryMapping,
	reverseObjectTypeQueryMapping,
} from '@/components/details/streaming-chart/streaming-chart-config';
import { PopularityRankTypes, StreamingChartObjectType } from '@/@types/graphql-types';
import { faFilm, faGlobeAmericas, faCalendar } from '@fortawesome/free-solid-svg-icons';

export interface FilterSelectItem {
	value: string | null;
	name: string;
}

interface FilterSelectProps {
	items: FilterSelectItem[];
	filterType: string;
	icon?: 'film' | 'globe-americas' | 'calendar';
	webLocale?: WebLocale | null;
	backgroundColor?: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'FilterSelect',
  props: {
    items: null,
    filterType: null,
    icon: null,
    webLocale: null,
    backgroundColor: { default: '#060d18' }
  },
  setup(__props: any) {

const props = __props as { items: FilterSelectItem[], filterType: string, icon?: 'film' | 'globe-americas' | 'calendar', webLocale?: WebLocale | null, backgroundColor: string };

const vm = getVm();

const ICONS = {
	film: faFilm,
	'globe-americas': faGlobeAmericas,
	calendar: faCalendar,
};



const preSelectedCondition = (item: FilterSelectItem) => {
	if (props.filterType === 'objectType' && vm.$route.query.t) {
		return (
			item.value ===
			(reverseObjectTypeQueryMapping[
				vm.$route.query.t as keyof typeof reverseObjectTypeQueryMapping
			] as StreamingChartObjectType)
		);
	}

	if (props.filterType === 'category' && vm.$route.query.ct) {
		return (
			item.value ===
			(reverseCategoryQueryMapping[
				vm.$route.query.ct as keyof typeof reverseCategoryQueryMapping
			] as PopularityRankTypes)
		);
	}

	if (props.filterType === 'country')
		return (
			item.value ===
			(vm.$route.query.c === 'global'
				? null
				: props.webLocale?.toUpperCase() === 'UK'
				? 'GB'
				: props.webLocale?.toUpperCase())
		);

	return item.value === 'WEEKLY_POPULARITY_SAME_CONTENT_TYPE';
};

return { __sfc: true,vm, ICONS, props, preSelectedCondition }
}

})